import React, { Component } from "react";

class ReadMore extends Component {
  state = {
    readMore: true,
  };

  toggleReadMore = () => {
    this.setState((prevState) => ({
      readMore: !prevState.readMore,
    }));

  };

  render() {
    const text = this.props.children;

    // This fixed the crash
    if (text === null) return null;
    // const length = this.props.length ? this.props.length : 100;

    // console.log("text==>", text);

    return this.props.viewTag ? (
      <span style={{ wordWrap: "break-word" }}>
        {this.state.readMore ? text.slice(0, 150) : text}
        {text.length > 150 ? (
          <a onClick={this.toggleReadMore}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") this.toggleReadMore();
            }}
            role="button"
            tabIndex="0"
          >
            {this.state.readMore ? " ...Read More" : " ...Show Less"}
          </a>

        ) : null}
      </span>
    ) : (
      <div style={{ wordWrap: "break-word" }}>
        {this.state.readMore ? text.slice(0, 150) : text}
        {text.length > 150 ? (
          <a onClick={this.toggleReadMore}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") this.toggleReadMore();
            }}
            role="button"
            tabIndex="0"
          >
            {this.state.readMore ? " ...Read More" : " ...Show Less"}
          </a>
        ) : null}
      </div>
    );
  }
}

export default ReadMore;



// WEBPACK FOOTER //
// ./src/components/read-more.js